import { PDFDocument, rgb, StandardFonts } from 'pdf-lib'

const createPrintFrame = url => {
  const iframe = document.createElement('iframe')
  iframe.style.position = 'absolute'
  iframe.style.width = '0px'
  iframe.style.height = '0px'
  iframe.style.border = 'none'
  iframe.style.visibility = 'hidden'
  iframe.src = url
  document.body.appendChild(iframe)
  return iframe
}

const cleanupPrint = (printFrame, printObjectUrl) => {
  if (printFrame && printFrame.parentNode) {
    document.body.removeChild(printFrame)
  }
  if (printObjectUrl) {
    URL.revokeObjectURL(printObjectUrl)
  }
}

const printPdf = async (url, userName, bucketNumbers) => {
  // This function prints PDF with packing initiated by user name on top of PDF

  // 1. Fetch PDF
  const response = await fetch(url)
  if (!response.ok) {
    throw new Error(`Failed to fetch PDF: ${response.statusText}`)
  }

  const existingPdfBytes = await response.arrayBuffer()

  // 2. Load PDF
  const pdfDoc = await PDFDocument.load(existingPdfBytes)
  const font = await pdfDoc.embedFont(StandardFonts.Helvetica)

  // 3. Write text on ALL pages
  const pages = pdfDoc.getPages()
  const bucketNumberstext = `(${bucketNumbers})`
  pages.forEach(page => {
    page.drawText(userName, {
      x: 474,
      y: 67,
      size: 6,
      font,
      color: rgb(0, 0, 0),
    })
    page.drawText(bucketNumberstext, {
      x: 474,
      y: 60,
      size: 6,
      font,
      color: rgb(0, 0, 0),
    })
  })

  // 4. Save modified PDF
  const modifiedPdfBytes = await pdfDoc.save()

  const pdfBlob = new Blob([modifiedPdfBytes], {
    type: 'application/pdf',
  })

  const printObjectUrl = URL.createObjectURL(pdfBlob)
  const printFrame = createPrintFrame(printObjectUrl)

  // 5. Print
  printFrame.onload = () => {
    printFrame.contentWindow.focus()
    printFrame.contentWindow.print()

    printFrame.contentWindow.addEventListener('afterprint', () => {
      cleanupPrint(printFrame, printObjectUrl)
    })
  }

  printFrame.onerror = () => {
    cleanupPrint(printFrame, printObjectUrl)
  }
}

// eslint-disable-next-line
export const printPDFs = pdfUrls => {
  pdfUrls.forEach(pdfData => {
    const {
      url, bucketNumbers, packingUser, prints = 1,
    } = pdfData

    // Printing in loop is working in edge browser, not working in chrome browser at the moment
    for (let printCount = 0; printCount < prints; printCount += 1) {
      printPdf(url, packingUser, bucketNumbers)
    }
  })
}
